  <template>
  <v-dialog
    :value="value"
    @input="(v) => $emit('input', v)"
    max-width="898"
    transition="dialog-transition"
    scrollable
    persistent
  >
    <v-card color="neutral700" class="pos-r px-16" flat>
      <v-card-title>
        <v-avatar size="24" @click="close" class="close_btn cursor-pointer">
          <img :src="require(`@/assets/icons/close.svg`)" />
        </v-avatar>
      </v-card-title>

      <v-card-text>
        <v-card color="transparent" flat>
          <div class="text-center">
            <p class="text-h5 font-weight-bold">
              {{ $t('ARTWORK.EDIT.COPYWRITING.UPLOAD_KEY_VISION_IMAGE') }}
            </p>
            <!-- <p>
              你可以透過主視覺海報放置在展場的起點和終點，
              <br />
              來給參觀者帶來更強烈的印象。儲存後可透過編輯調整尺寸
            </p>
            <p>
              你可以透過放置主視覺海報，
              <br />
              給參觀者帶來更強烈的印象，並可在儲存後調整尺寸
            </p> -->
            <p>
              {{
                $t(
                  'ARTWORK.EDIT.COPYWRITING.PLACE_KEY_VISION_PROVIDE_IMPRESSION'
                )
              }}
              <br />
              {{ $t('ARTWORK.EDIT.COPYWRITING.YOU CAN ADJUST AFTER UPLOADED') }}
            </p>
          </div>

          <v-card-text>
            <SizeBox height="24" />

            <div class="flex-center">
              <label
                @dragover.prevent
                @dragenter="isGrabing = true"
                @drop.prevent="handleDrop"
                @dragend="isGrabing = false"
                @dragleave="isGrabing = false"
                @click="(e) => !!previewImg && e.preventDefault()"
                :class="!!previewImg ? 'w90p' : 'w100p'"
                class="cursor-pointer"
              >
                <v-img
                  :src="previewImg"
                  :aspect-ratio="
                    !!previewImg ? null : keyVisionSpec.aspectRatio
                  "
                  class="elevation-3"
                  contain
                >
                  <div
                    class="file_area fill-all d-flex justify-center align-end"
                    :class="{ isGrabing, isError: !!fileEmptyError }"
                    v-if="!previewImg"
                  >
                    <div class="text-center">
                      <v-chip color="neutral400" label>
                        <v-icon class="mr-2">mdi-camera-enhance</v-icon>
                        <!-- 上傳主視覺海報 -->
                        {{
                          $t('ARTWORK.EDIT.COPYWRITING.UPLOAD_KEY_VISION_IMAGE')
                        }}
                      </v-chip>
                      <SizeBox height="12" />
                      <p class="text-left">
                        {{
                          $t(
                            'ARTWORK.EDIT.COPYWRITING.SUPPORTS_JPG_PNG_ONLY_MAXIMUM'
                          )
                        }}
                        {{ fileLimit }} MB
                        <br />
                        {{ $t('ARTWORK.EDIT.COPYWRITING.MAX_RESOLUTION') }}:{{
                          keyVisionSpec.limitWidth
                        }}px * {{ keyVisionSpec.limitHeight }}px
                      </p>
                      <SizeBox height="32" />
                    </div>
                  </div>
                </v-img>
                <input
                  ref="fileInput"
                  @change="handleFileChange"
                  type="file"
                  hidden
                  accept=".jpg,.jpeg,.png"
                />
              </label>
            </div>
            <div class="text-center" v-show="!!previewImg">
              <SizeBox height="24" />
              <v-btn text @click="previewImg = null">
                <v-icon>mdi-reload</v-icon>
                {{ $t('ARTWORK.EDIT.WORD.UPLOAD_AGAIN') }}
              </v-btn>
            </div>
            <v-card flat color="transparent" min-height="24">
              <v-slide-y-transition>
                <div v-if="!!fileEmptyError" class="flex-center">
                  <span class="error--text">
                    {{ fileEmptyError }}
                  </span>
                </div>
              </v-slide-y-transition>
              <SizeBox height="24" />
            </v-card>

            <v-form ref="form">
              <v-text-field
                :label="$t('ARTWORK.EDIT.WORD.KEY_VISION_NAME')"
                v-model="form.name"
                :rules="[$rules.required]"
                background-color="neutral700"
                outlined
              ></v-text-field>
            </v-form>
          </v-card-text>
        </v-card>
      </v-card-text>

      <v-card-actions class="mb-8">
        <v-row>
          <v-col cols="12" class="flex-center">
            <v-btn width="120" outlined @click="close">
              {{ $t('COMMON.WORD.CANCEL') }}
            </v-btn>
            <SizeBox width="16" />
            <v-btn
              width="120"
              color="primary"
              @click="submit"
              :loading="isSubmiting"
            >
              {{ $t('COMMON.WORD.SAVE_CHANGES') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-dialog
      v-model="isShowClipper"
      persistent
      max-width="960"
      transition="dialog-transition"
    >
      <v-card class="pos-r">
        <div class="d-flex">
          <v-avatar size="24" @click="close" class="close_btn cursor-pointer">
            <img :src="require(`@/assets/icons/close.svg`)" />
          </v-avatar>
        </div>
        <v-card-title class="flex-center">
          <span class="text-h5">
            {{ $t('ARTWORK.EDIT.COPYWRITING.CROP_KEY_VISION') }}
          </span>
        </v-card-title>
        <v-card-text>
          <clipper-basic
            ref="CLIPPER"
            bg-color="transparent"
            :src="imageDataUrl"
            :ratio="keyVisionSpec.aspectRatio"
            :area="70"
          />
        </v-card-text>

        <v-card-actions class="flex-center">
          <v-btn outlined @click="cancelClip">
            {{ $t('COMMON.WORD.CANCEL') }}
          </v-btn>
          <v-btn color="primary" depressed @click="doClip">
            {{ $t('ARTWORK.EDIT.COPYWRITING.CROP') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { addKeyVision } from '@/api/panel/exhibitions';
import { addImageByCategory } from '@/api/panel/images';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    workData: {
      type: Object,
      default: null,
      required: true
    },
    keyVisionSpec: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      step: 1,
      isGrabing: false,
      previewImg: null,
      previewFile: null,
      holdingFile: null,
      fileEmptyError: null,
      isUploadingPreview: false,
      isSubmiting: false,
      isShowClipper: false,

      fileLimit: 5,

      frameStrokeWidth: 24,
      previewedImageName: '',

      form: {
        index: null,
        keyVisionImageId: null,
        name: ''
      }
    };
  },

  computed: {
    imageDataUrl() {
      return this.previewFile ? URL.createObjectURL(this.previewFile) : '';
    }
  },

  watch: {
    value(v) {
      v ? this.init() : this.reset();
    },
    previewImg(v) {
      this.fileEmptyError = null;
      if (!v) {
        this.$refs.fileInput.value = null;
        this.holdingFile = null;
      }
    },
    isGrabing() {
      this.fileEmptyError = null;
    },
    step(v) {
      //
    }
  },

  methods: {
    init() {
      if (this.workData.data) {
        const image = this.workData.data.keyVisionImage;
        this.previewImg = image.url;
        this.form.index = this.workData.index;
        this.form.keyVisionImageId = image.id;
        this.form.name = this.workData.data.name;
      }
    },
    reset() {
      const originData = this.$options.data();
      Object.keys(originData).forEach((key) => {
        this.$set(this.$data, key, originData[key]);
      });
      this.$refs.form.reset();
    },
    handleWheel(e) {
      if (this.previewedImageName) return;
      if (e.deltaY > 0 && this.workWidthPercent > 39) this.workWidthPercent--;
      if (e.deltaY < 0 && this.workWidthPercent < 100) this.workWidthPercent++;
    },
    close() {
      this.$emit('input', false);
    },
    cancelClip() {
      this.previewImg = null;
      this.holdingFile = null;
      this.previewFile = null;
      this.fileEmptyError = null;
      this.isUploadingPreview = false;
      this.isShowClipper = false;
    },
    async doClip() {
      const canvas = this.$refs.CLIPPER.clip({
        maxWPixel: 2000
      });

      this.previewImg = canvas.toDataURL();

      const { file, imgURL } = await this.$shrinkImg(this.previewImg, {
        targetSize: 1048576 * 2,
        aspectRatio: this.keyVisionSpec.aspectRatio
      });

      this.holdingFile = file;
      this.previewImg = imgURL;
      this.isShowClipper = false;
    },
    async submit() {
      let flag = true;
      if (!this.$refs.form.validate()) flag = false;
      if (!this.form.keyVisionImageId && !this.holdingFile) {
        this.fileEmptyError = this.$t(
          'ARTWORK.EDIT.COPYWRITING.UPLOAD_YOUR_FILE'
        );
        flag = false;
      }

      if (!flag) return;

      this.isSubmiting = true;

      if (this.holdingFile) {
        const formData = new FormData();
        formData.append('file', this.holdingFile);

        const { id, url, error } = await addImageByCategory({
          category: 'keyVision',
          data: formData
        });

        if (error) {
          this.$toast.error(
            `${this.$t('ARTWORK.EDIT.TOAST.ALERT.BUILD_FAIL')} ${error.message}`
          );
          this.isSubmiting = false;
          return;
        }

        this.form.keyVisionImageId = id;
      }

      this.form.index = this.workData.index;

      const Work = await addKeyVision({
        id: this.$route.params.expoId,
        ...this.form
      });

      this.$emit('save', Work);
      this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.BUILD_SUCCESSFUL'));

      this.isSubmiting = false;

      this.$emit('input', false);
    },
    handleDrop(e) {
      this.isGrabing = false;
      if (e.dataTransfer.files.length) {
        const file = e.dataTransfer.files[0];
        const exts = ['jpg', 'jpeg', 'png'];

        if (exts.includes(file.name.split('.').pop())) {
          this.handlePreview(file);
        } else {
          this.$toast.error('ARTWORK.EDIT.TOAST.ALERT.FILE_FORMAT_NOT_MATCH');
        }
      }
    },
    handleFileChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.handlePreview(file);
      }
    },

    handlePreview(file) {
      if (file.size > 1048576 * this.fileLimit) {
        this.$toast.error(
          `${this.$t('ARTWORK.EDIT.COPYWRITING.FILE_SIZE_NOT_EXCEED')} ${
            this.fileLimit
          } MB`
        );
        return;
      }

      this.previewFile = file;
      this.isShowClipper = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.close_btn {
  position: absolute;
  top: 8px;
  right: 8px;
}

.file_area {
  * {
    user-select: none;
  }
  position: relative;
  border: 1px dashed;
  border-color: $neutral300;
  border-radius: 6px;
  background-color: $neutral700;

  &.isError {
    border-color: $error;
  }

  &.isGrabing {
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: calc(100% - 8px);
      height: calc(100% - 8px);
      background-color: rgba($neutral100, $alpha: 0.6);
      border-radius: 6px;
      border: 2px solid $primary;
    }
  }
}

.image_in_frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>